import { render, staticRenderFns } from "./enclosureModel copy.vue?vue&type=template&id=88c7e8ae&scoped=true"
import script from "./enclosureModel copy.vue?vue&type=script&lang=js"
export * from "./enclosureModel copy.vue?vue&type=script&lang=js"
import style0 from "./enclosureModel copy.vue?vue&type=style&index=0&id=88c7e8ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c7e8ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c7e8ae')) {
      api.createRecord('88c7e8ae', component.options)
    } else {
      api.reload('88c7e8ae', component.options)
    }
    module.hot.accept("./enclosureModel copy.vue?vue&type=template&id=88c7e8ae&scoped=true", function () {
      api.rerender('88c7e8ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionnaire/customerManage/questionnaireList/components/enclosureModel copy.vue"
export default component.exports